import React from 'react';
import FeesModal from '../feesModal/FeesModal';

interface AddCardHolderFeeModalProps {
    fee: number | undefined;
    handleSubmit: () => void;
    closeModal: () => void;
}

function AddCardHolderFeeModal({
    fee,
    handleSubmit,
    closeModal,
}: AddCardHolderFeeModalProps) {
    return (
        <FeesModal
            action="Adding an additional cardholder"
            fee={fee}
            handleSubmit={handleSubmit}
            closeModal={closeModal}
        />
    );
}

export default AddCardHolderFeeModal;
